import { useSelector } from 'react-redux';

import './edit-single-card-status.scss';
import SmallPanel from 'features/cards/modals/card-detail-modal/SmallPanel';
import SelectStatusForm, { SelectStatusFormValues } from './SelectStatusForm';
import Env from 'Env';

const UPDATE_STATUS_FORM_ID = 'update-status-form';

interface EditCardStatusProps {
  // eslint-disable-next-line no-unused-vars
  onSubmit: (values: SelectStatusFormValues) => void;
  disabled?: boolean;
  headless?: boolean;
  currentStatus?: string;
}

/**
 * @param {Object} props - The component's props.
 */
const EditCardStatus = ({ onSubmit, disabled, headless, currentStatus }: EditCardStatusProps) => {
  const cardDetail = useSelector((state: any) => state.cardDetailView.cardDetail);
  const currentSelectedStatus = currentStatus || cardDetail.currentStatus;

  // Feature flag: When VITE_EV_WAY4 is disabled, block editing for AmpCharge cards
  const isAmpChargeRestricted =
    typeof Env.getIsEvWay4Enabled === 'function'
      ? !Env.getIsEvWay4Enabled() && cardDetail?.ampChargeEnabled
      : cardDetail?.ampChargeEnabled;
  const message = isAmpChargeRestricted
    ? `Card status can't be updated through the Card Portal. For support, please call ${Env.getCustomerServicePhone()}.`
    : '';

  return (
    <SmallPanel
      title='Update status'
      formId={UPDATE_STATUS_FORM_ID}
      disabled={disabled || isAmpChargeRestricted}
      headless={headless}
      buttons={[
        {
          label: 'Submit',
          formId: UPDATE_STATUS_FORM_ID,
        },
      ]}
    >
      <SelectStatusForm
        formId={UPDATE_STATUS_FORM_ID}
        currentStatus={currentSelectedStatus}
        footerMessage={message}
        onSubmit={onSubmit}
        disabled={disabled || isAmpChargeRestricted}
      />
    </SmallPanel>
  );
};

export default EditCardStatus;
